import { CircleCheckBig } from "lucide-react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import bannerImage from "../../assets/centers/iqac_11zon.jpg";
import ImageHeading from "../../components/ui/ImageHeading";
import CoreActivities from "../../components/CenterOfExcellence/CoreActivities";
import KeyObjectives from "../../components/CenterOfExcellence/KeyObjectives";
import IQACMission from "../../components/CenterOfExcellence/IQACMission";
// import PublicationCarousel from "../../components/CenterOfExcellence/PublicationCarousel";
// import TeamCarousel from "../../components/CenterOfExcellence/TeamCarousel";
// import FeaturedEvents from "../../components/ui/FeaturedEvents";
import ResearchCTA from "../../components/ui/ResearchCTA";
import useAxiosPublic from "../../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../../components/Layout/LoadingPage";

const IQAC = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: iqacApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["iqacApi"],
    queryFn: async () => {
      const res = await axiosPublic.get("/centers/iqac");
      return res?.data?.data?.iqac;
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  console.log(iqacApiData, "iqac data");
  return (
    <div>
      <ImageHeading
        heading="Institutional Quality Assurance Cell (IQAC)"
        imageUrl={bannerImage}
      />
      <div className="container px-4 mx-auto md:px-8 ">
        <div className="gap-8 my-12 ">
          <div>
            <div>
              <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
                {iqacApiData?.title}
              </h3>
              <div className="py-6 leading-loose text-gray-700 ">
                <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                  {iqacApiData?.description}
                </ReactMarkdown>
              </div>
            </div>
            <KeyObjectives objectives={iqacApiData?.key_activities} />
            <CoreActivities
              data={iqacApiData?.core_activities}
              title={iqacApiData?.core_activities?.title}
            />
            <IQACMission
              title={iqacApiData?.ambition?.title}
              details={iqacApiData?.ambition?.description}
              data={iqacApiData?.ambition?.points}
            />
            <div className="grid grid-cols-1 gap-8 my-12 lg:grid-cols-2">
              {/* <div className="">
                <h4 className="text-2xl font-bold text-black lg:text-3xl font-domine">
                  Ambition
                </h4>
                <p className="text-sm leading-loose text-gray-500 lg:text-base ">
                  To foster a culture of excellence in education, research, and
                  community engagement at ZNRF University by ensuring a robust
                  and sustainable quality assurance framework that aligns with
                  international standards and national aspirations.
                </p>
                <ul className="py-6 space-y-6 leading-loose text-gray-700">
                  <li className="flex flex-row items-center gap-5 ">
                    <CircleCheckBig className=" text-primary-500" /> Enhancing
                    Academic Excellence: To promote academic innovation,
                    encourage faculty development, and continuously improve
                    teaching and learning processes to meet global standards.
                  </li>
                  <li className="flex flex-row items-center gap-5 ">
                    <CircleCheckBig className=" text-primary-500" />
                    Quality Assurance Mechanisms
                  </li>
                  <li className="flex flex-row items-center gap-5 ">
                    <CircleCheckBig className=" text-primary-500" /> Research
                    and Innovation
                  </li>
                  <li className="flex flex-row items-center gap-5 ">
                    <CircleCheckBig className=" text-primary-500" /> Stakeholder
                    Engagement
                  </li>
                  <li className="flex flex-row items-center gap-5 ">
                    <CircleCheckBig className=" text-primary-500" /> Engage
                    stakeholders, including students, employers, and alumni, in
                    quality enhancement initiatives.
                  </li>
                </ul>
              </div> */}
              <div className="">
                <h4 className="text-2xl font-bold text-black lg:text-3xl font-domine">
                  {iqacApiData?.core_values?.title}
                </h4>
                <ul className="py-6 space-y-6 leading-loose text-gray-700">
                  {iqacApiData?.core_values?.points?.map((point, idx) => (
                    <li key={idx} className="flex flex-row items-center gap-5 ">
                      <span>
                        <CircleCheckBig className=" text-primary-500" />
                      </span>
                      {point?.point}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="">
                <h4 className="text-2xl font-bold text-black lg:text-3xl font-domine">
                  Achievements
                </h4>
                <ul className="py-6 space-y-6 leading-loose text-gray-700">
                  {iqacApiData?.achievements?.points?.map((point, idx) => (
                    <li key={idx} className="flex flex-row items-center gap-5 ">
                      <span>
                        <CircleCheckBig className=" text-primary-500" />
                      </span>
                      {point?.point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="py-12 space-y-20">
              {/* <PublicationCarousel
                data={iqacApiData?.publication_with_urls?.publication_list}
                title={iqacApiData?.publication_with_urls?.title}
              /> */}

              {/* <TeamCarousel title={"   IQAC Team"} /> */}
              {/* <FeaturedEvents /> */}
              <ResearchCTA
                title={iqacApiData?.contact?.title}
                mail={iqacApiData?.contact?.email}
                number={iqacApiData?.contact?.phone}
                description={iqacApiData?.contact?.description}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IQAC;
